import React from "react";
import ReactDOM from "react-dom";
import "./Styles/index.css";

import Rotas from "./Routes/routes"

ReactDOM.render(<Rotas/>, document.getElementById("root"));


